<div class="console-page">
  <div class="console-content">
    <app-page-header
      title="Checkout"
      description="Configurá y probá el SDK de Checkout Epago."
    ></app-page-header>

    <form [formGroup]="myForm">
      <input type="hidden" formControlName="orderId" />

      <app-console-section title="Configuración API">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="checkout2-env">Host SDK</label>
            <select
              id="checkout2-env"
              class="console-select"
              formControlName="env"
              (change)="changeEnvironment($event)"
            >
              <option value="QAnL&F">QA Nuevo Look&amp;Feel</option>
              <option value="QAV1">QA</option>
              <option value="PROD/QA">SDK de PROD con ambiente de QA</option>
              <option value="PROD">PROD</option>
              <option value="PRODCORD">PROD Cord-1.0.0</option>
              <option value="SDK_VERSION_OLD">SDK MAIN VERSION OLD</option>
              <option value="REACT_SDK">SDK REACT</option>
              <option value="REACT_SDK_DEV">DEV REACT SDK</option>
              <option value="DEV">DEV</option>
            </select>
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-api">Módulo</label>
            <select
              id="checkout2-api"
              class="console-select"
              formControlName="api"
              (change)="changeApi($event)"
            >
              <option value="generico">FORM GENERICO</option>
            </select>
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-merchantKey">API Key</label>
            <input
              id="checkout2-merchantKey"
              class="console-input"
              formControlName="merchantKey"
              placeholder="API Key"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-merchantToken">Secret Key</label>
            <input
              id="checkout2-merchantToken"
              class="console-input"
              formControlName="merchantToken"
              placeholder="Clave secreta"
              type="text"
            />
          </div>

          <div class="console-field">
            <span class="console-field__label">ID de orden</span>
            <div class="console-field__order-id">
              <span class="mono">{{ myForm.get('orderId')?.value }}</span>
              <app-copy-button [value]="myForm.get('orderId')?.value" ariaLabel="Copiar ID de orden"></app-copy-button>
            </div>
            <span class="console-field__hint">Se actualiza automáticamente cada segundo</span>
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-versionSdk">Versión SDK</label>
            <input
              id="checkout2-versionSdk"
              class="console-input"
              formControlName="versionSdk"
              placeholder="Versión del SDK"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-modeSdk">Modo</label>
            <input
              id="checkout2-modeSdk"
              class="console-input"
              formControlName="modeSdk"
              placeholder="Ej. VALIDATE"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-paymentMethod">Método de pago</label>
            <select
              id="checkout2-paymentMethod"
              class="console-select"
              formControlName="paymentMethod"
              (change)="changePaymentMethod($event)"
            >
              <optgroup *ngFor="let group of paymentMethodGroups" [label]="group.label">
                <option *ngFor="let opt of group.options" [value]="opt.value">{{ opt.label }}</option>
              </optgroup>
            </select>
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-currency">Moneda</label>
            <input
              id="checkout2-currency"
              class="console-input"
              formControlName="currency"
              placeholder="Moneda"
            />
          </div>

          <div class="console-field console-form-grid__full">
            <label class="console-field__label" for="checkout2-signedElement">Signed Element</label>
            <input
              id="checkout2-signedElement"
              class="console-input"
              formControlName="signedElement"
              placeholder="Cadena firmada (order + moneda + monto)"
            />
          </div>

          <div class="console-field console-form-grid__full">
            <label class="console-checkbox">
              <input type="checkbox" formControlName="payWithQr" />
              Pagar con QR (qrPayment: true en el config del SDK)
            </label>
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Pago">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="checkout2-discounts">Descuento</label>
            <input
              id="checkout2-discounts"
              class="console-input"
              formControlName="discounts"
              placeholder="Descuento"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-shipping">Envío</label>
            <input
              id="checkout2-shipping"
              class="console-input"
              formControlName="shipping"
              placeholder="Envío"
            />
          </div>

          <div class="console-field">
            <label class="console-field__label" for="checkout2-fee">Tarifa</label>
            <input
              id="checkout2-fee"
              class="console-input"
              formControlName="fee"
              placeholder="Tarifa"
            />
          </div>
        </div>

        <div class="minicart-container" [formGroup]="minicartItems">
          <div class="console-form-grid">
            <div class="console-field">
              <label class="console-field__label" for="minicart-sku">SKU</label>
              <input id="minicart-sku" class="console-input" formControlName="sku" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="minicart-name">Nombre</label>
              <input id="minicart-name" class="console-input" formControlName="name" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="minicart-category">Categoría</label>
              <input id="minicart-category" class="console-input" formControlName="category" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="minicart-amount">Precio unitario</label>
              <input id="minicart-amount" class="console-input" formControlName="amount" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="minicart-quantity">Cantidad</label>
              <input id="minicart-quantity" class="console-input" formControlName="quantity" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="minicart-discount">Descuento ítem</label>
              <input id="minicart-discount" class="console-input" formControlName="discount" />
            </div>
            <div class="console-field">
              <label class="console-field__label" for="minicart-shipping">Envío ítem</label>
              <input id="minicart-shipping" class="console-input" formControlName="shipping" />
            </div>
          </div>

          <div class="add-item-button">
            <button class="console-btn" type="button" (click)="addMinicartItem()">Agregar ítem</button>
          </div>

          <div class="cart-items-container" *ngIf="items.length; else emptyCart">
            <div class="demo-minicart-row demo-minicart-row--head">
              <span>SKU</span>
              <span>Producto</span>
              <span>Total</span>
              <span>Cant.</span>
              <span></span>
            </div>
            <div *ngFor="let item of items; let i = index" class="demo-minicart-row">
              <span class="demo-minicart-row__mono">{{ item.sku }}</span>
              <span>{{ item.name }}</span>
              <span>{{ item.amount }}</span>
              <span>{{ item.quantity }}</span>
              <button
                class="console-btn"
                type="button"
                (click)="removeMinicartItem(i)"
                aria-label="Quitar"
              >
                Quitar
              </button>
            </div>
          </div>
          <ng-template #emptyCart>
            <p class="demo-minicart-empty">No hay ítems en el carrito. Agregá uno para probar el minicart.</p>
          </ng-template>
        </div>
      </app-console-section>

      <app-console-section title="Cliente">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="checkout2-identifier">Identificador</label>
            <input
              id="checkout2-identifier"
              class="console-input"
              formControlName="identifier"
              placeholder="Identificador"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="checkout2-email">Email</label>
            <input
              id="checkout2-email"
              class="console-input"
              formControlName="email"
              type="email"
              placeholder="Email"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="checkout2-name">Nombre</label>
            <input
              id="checkout2-name"
              class="console-input"
              formControlName="name"
              placeholder="Nombre"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="checkout2-lastname">Apellido</label>
            <input
              id="checkout2-lastname"
              class="console-input"
              formControlName="lastname"
              placeholder="Apellido"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="checkout2-documentNumber">DNI</label>
            <input
              id="checkout2-documentNumber"
              class="console-input"
              formControlName="documentNumber"
              placeholder="Documento"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="checkout2-phone">Teléfono</label>
            <input
              id="checkout2-phone"
              class="console-input"
              formControlName="phone"
              placeholder="Teléfono"
            />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Dirección">
        <div class="console-form-grid">
          <div class="console-field console-form-grid__full">
            <label class="console-field__label" for="checkout2-address1">Dirección</label>
            <input
              id="checkout2-address1"
              class="console-input"
              formControlName="address1"
              placeholder="Dirección"
            />
          </div>
        </div>
      </app-console-section>

      <app-console-section
        title="Metadata"
        description="Campos name/value que se envían en order.metadata. El mismo formato que PayLink usa para createdFromLink."
      >
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="checkout2-metadata-name">Nombre</label>
            <input
              id="checkout2-metadata-name"
              class="console-input"
              formControlName="metadataName"
              placeholder="createdFromLink"
            />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="checkout2-metadata-value">Valor</label>
            <input
              id="checkout2-metadata-value"
              class="console-input"
              formControlName="metadataValue"
              placeholder="true"
            />
          </div>
        </div>

        <div class="add-item-button metadata-actions">
          <button class="console-btn" type="button" (click)="addMetadataField()">Agregar campo</button>
          <button class="console-btn" type="button" (click)="addCreatedFromLinkMetadata()">
            Agregar createdFromLink
          </button>
        </div>

        <div class="cart-items-container" *ngIf="metadataFields.length; else emptyMetadata">
          <div class="metadata-row metadata-row--head">
            <span>Nombre</span>
            <span>Valor</span>
            <span></span>
          </div>
          <div *ngFor="let field of metadataFields.controls; let i = index" class="metadata-row">
            <span class="demo-minicart-row__mono">{{ field.get('name')?.value }}</span>
            <span>{{ field.get('value')?.value }}</span>
            <button
              class="console-btn"
              type="button"
              (click)="removeMetadataField(i)"
              aria-label="Quitar campo de metadata"
            >
              Quitar
            </button>
          </div>
        </div>
        <ng-template #emptyMetadata>
          <p class="demo-minicart-empty">No hay campos de metadata. Agregá uno para enviarlo en la orden.</p>
        </ng-template>
      </app-console-section>
    </form>
  </div>

  <div class="console-action-bar">
    <span class="console-action-bar__total">
      Total
      <span class="console-action-bar__amount">S/ {{ calculateTotal() }}</span>
    </span>
    <button class="console-btn" type="button" (click)="generatePayment('#cart-container-2')">Embebido</button>
    <button class="console-btn" type="button" (click)="generatePayment('#cart-container-3')">Sin formulario</button>
    <button class="console-btn console-btn--primary" type="button" (click)="generatePayment('#cart-container')">
      Pagar
    </button>
  </div>

  <div
    #paymentOverlay
    class="demo-pay-overlay"
    [class.demo-pay-overlay--open]="paymentOverlayOpen"
    role="dialog"
    aria-modal="true"
    aria-label="Pago"
  >
    <div class="demo-pay-dialog__inner">
      <div class="demo-pay-dialog__header">
        <button
          type="button"
          class="demo-pay-dialog__close"
          (click)="closePaymentWindow(); $event.stopPropagation()"
          aria-label="Cerrar"
        >
          ×
        </button>
      </div>
      <div class="pay-container">
        <p *ngIf="paymentSdkLoading" class="demo-pay-overlay__loading">Cargando formulario de pago…</p>
        <div id="cart-container" class="epago-container" #cartContainer></div>
      </div>
    </div>
  </div>

  <div id="cart-container-2" class="epago-container embedded-sdk" #cartContainer2></div>
  <div id="cart-container-3" class="epago-container embedded-sdk" #cartContainer3></div>
</div>
